import type * as React from "react";

import { useMenuButton_unstable } from "@fluentui/react-components";
import type { MenuButtonProps } from "@fluentui/react-components";

import { useMergedTooltipAndKeytipRef } from "@1js/acui-hooks";

import { deriveButtonKeytip } from "@1js/acui-keytip";
import { useAppMenuButtonState } from "./useAppMenuButtonState";
import type { AppMenuButtonProps, AppMenuButtonState } from ".";

export const useAppMenuButton = (
  props: AppMenuButtonProps,
  ref: React.Ref<HTMLButtonElement>
): AppMenuButtonState => {
  const { disabled, customKeytipFunction } = props;

  // Set useDirectClick to true for correct keytip behavior
  const mergedRefWithKeytip = useMergedTooltipAndKeytipRef(
    {
      ...props,
      deriveKeytip: customKeytipFunction ?? deriveButtonKeytip,
      useDirectClick: true,
    },
    ref,
    "AppButton"
  );

  const menuButtonState = useMenuButton_unstable(
    {
      ...props,
      type: "button",
      disabledFocusable: disabled,
    } as MenuButtonProps,
    mergedRefWithKeytip
  );

  return useAppMenuButtonState(props, menuButtonState);
};
